import React from 'react';

import css from './StoragePage.module.css';
import StorageProductsComponent from "../../components/storageSection/StorageProductsComponent/StorageProductsComponent";


const StoragePage = () => {
    return (
        <section className={css.wrap}>
            <StorageProductsComponent />
        </section>
    );
};

export { StoragePage };
